<template>
	<div
		class="side"
	>
		<div
			class="bg-side"
			@click="toggleSide"
		></div>

		<div
			class="side-container flex-column pa-10"
		>
			<div
				class="logo-position  justify-space-between items-center"
			>
				<div class="size-px-20 font-weight-bold">{{ title }}</div>

				<button @click="toggleSide"><v-icon>mdi-close</v-icon></button>
			</div>

			<div class="mt-20 justify-start gap-10">
				{{ user.member_name }} ({{ user.member_id }})
			</div>

			<hr class="top-line-primary-m mt-10" />

			<ul
				class="side-content overflow-y-auto"
			>
				<template
					v-for="(item, index) in items"
				>
					<li
						v-if="!item.not_view"
						:key="'category_' + index"
					>
						<div
							class=" justify-space-between items-center under-line ptb-10"
							@click="toList(item)"
						>
						<span class="font-weight-bold">{{ item.name }}</span>
						<v-icon
							v-if="item.is_on"
						>mdi mdi-chevron-up</v-icon>
						<v-icon
							v-else
						>mdi mdi-chevron-down</v-icon>

						</div>
					</li>
				</template>
				<li>

					<div
						class=" justify-space-between items-center under-line ptb-10"
						@click="toNotice"
					>
						<span class="font-weight-bold">고객 센터</span>
					</div>
				</li>
			</ul>

			<div class="mt-30 justify-space-between gap-10">
				<button
					v-if="user && user.member_id"
					class="text-12 font-weight-500 btn-round btn-outline btn-ss"
					@click="toMypage"
				>마이페이지</button>
				<button
					v-if="user && user.member_id"
					class="btn-round btn-outline btn-ss"
					@click="toLogout"
				>로그아웃</button>
			</div>

		</div>
	</div>
</template>

<script>

	export default{
		name: 'Side'
		,props: ['user', 'shop_info', 'category']
		,data: function(){
			return {
				items: [
					{
						name: '현장 관리'
						, path: 'ProjectList'
						, auth: 3
						, not_view: !this.user.member_id || this.user.member_level < 3 ? true : false
					}
					, {
						name: '인원 관리'
						, path: 'MemberList'
						, auth: 3
						, not_view: !this.user.member_id || this.user.member_level < 3 ? true : false
					}
				]
				, title: process.env.VUE_APP_TITLE
			}
		}
		,computed: {

		}
		,methods: {
			toItem: function(category){
				this.toggleSide()

				this.$bus.$emit('to', { name: 'ProductList', query: { category: category} })
			}
			,toggleSide: function(){
				this.$emit('toggleSide')
			}
			,logout: function(){
				let auto_login = localStorage.getItem(process.env.VUE_APP_NAME + 'A')

				if(auto_login) {

					if(confirm('로그아웃시 자동로그인도 해제됩니다. 로그아웃 하시겠습니까?')) {

						localStorage.removeItem(process.env.VUE_APP_NAME + 'A')
						localStorage.removeItem(process.env.VUE_APP_NAME + 'N')
						localStorage.removeItem(process.env.VUE_APP_NAME + 'P')

						sessionStorage.removeItem(process.env.VUE_APP_NAME + 'T')
						sessionStorage.removeItem(process.env.VUE_APP_NAME + 'T2')
						document.location.href= '/Login'
					}

				}else{

					if(confirm('로그아웃 하시겠습니까?')){
						sessionStorage.removeItem(process.env.VUE_APP_NAME + 'T')
						sessionStorage.removeItem(process.env.VUE_APP_NAME + 'T2')
						document.location.href= '/Login'
					}
				}
			}
			, onCategory: function(item){
				this.$set(item, 'is_on', !item.is_on)
			}
			, toNotice: function(){
				this.$bus.$emit('to', { name: 'CustomerCenter', params: {b_code: 'b_notice'}})
			}
			, toPoint: function(point){
				this.$bus.$emit('to', {name: 'PointItem', query: {point: point.value}})
			}
			, toList: function(item){
				this.$bus.$emit('to', { name: item.path, params: item.params})
			}

			, toLogin: function(){
				this.$bus.$emit('to', { name: 'Login'})
			}
			, toJoin: function(){
				this.$bus.$emit('to', { name: 'Join'})
			}
			, toMypage: function(){
				this.$bus.$emit('to', { name: 'MyPage'})
			}
			, toBoard: function(b_code){
				this.$bus.$emit('to', { name: 'CustomerCenter', params: { b_code: b_code }})
			}
			, toShopping: function(){
				this.$bus.$emit('to', { name: 'OrderList', params: { type: 'all'}})
			}
			, toCart: function(){
				this.$bus.$emit('to', { name: 'Cart'})
			}
			, toLogout: function(){
				if(confirm("로그아웃 하시겠습니까?")){
					this.$bus.$emit('logout')
				}
			}
		}
		,created: function(){
		}
	}
</script>

<style>

	.side {
		width: 100%; height: 100%;
		position: fixed; left: 0; top: 0; z-index: 98;
	}
	.bg-side {
		width: 100%; height: 100%;
		position: fixed; left: 0; top: 0; z-index: 98;
		background-color: gray;
		opacity: 0.5;
	}
	.side-container{
		width: 80%; height: 100%;
		max-width: 300px;
		position: relative;  z-index: 99;
		background-color: white;
		overflow-y: auto;
	}

	.side-container {

	}

	.li-side-content {
		padding: 10px 0;
		border-bottom: 1px solid #ddd;
	}

	.li-side-depth-0 span {
		font-weight: bold;
	}
	.li-side-depth-1 {
		text-indent: 10px;
	}
	.li-side-depth-2 {
		text-indent: 20px;
	}
	.li-side-depth-3 {
		text-indent: 20px;
	}
	.li-side-depth-4 {
		text-indent: 30px;
	}

	dt, dd { display: inline-block}
</style>